import React, { FunctionComponent } from "react";
import { ThemeProvider } from "styled-components";
import { StylesProvider } from "@material-ui/core/styles";
import MobileBreakpoints, {
  MobileFirst,
} from "../../settings/MobileBreakpoints";
import { ADAFont, FontWithLineHeight } from "../../settings/FontFormat";

type ThemeProps = {
  integrationConfigs: any;
};

const Theme: FunctionComponent<ThemeProps> = ({
  children,
  integrationConfigs,
}) => {
  return (
    <aside>
      <StylesProvider injectFirst>
        <ThemeProvider
          theme={{
            primaryFont: integrationConfigs.primary_font,
            secondaryFont: integrationConfigs.secondary_font,
            primaryColor: `#${integrationConfigs.primary_color}`,
            secondaryColor: `#${integrationConfigs.secondary_color}`,
            whiteLabel: integrationConfigs.white_label,
            btnColor: `#${integrationConfigs.btn_color}`,
            btnHoverColor: `#${integrationConfigs.btn_hover_color}`,
            btnPressedColor: `#${integrationConfigs.btn_pressed_color}`,
            ...MobileBreakpoints,
            ...MobileFirst,
            ADAFont,
            FontWithLineHeight,
          }}
        >
          {children}
        </ThemeProvider>
      </StylesProvider>
    </aside>
  );
};

Theme.defaultProps = {
  integrationConfigs: {
    primary_font: "'Roboto', Arial, sans-serif",
    secondary_font: "'Work Sans', Arial, sans-serif",
    primary_color: "000000",
    secondary_color: "FFFFFF",
    white_label: "The Guestbook",
    btn_color: "292C2C",
    btn_hover_color: "555F66",
    btn_pressed_color: "111415",
  },
};

export default Theme;
